import Vue from 'vue';
import VeeValidate, {Validator} from 'vee-validate'
import pl from 'vee-validate/dist/locale/pl'

import Pesel from 'Utils/Pesel'
import PWZ from 'Utils/PWZ'

Vue.use(VeeValidate, {
    events: 'input|blur'
})

Validator.localize('pl', pl)

Validator.extend('PWZ', {
    getMessage: field => 'Podano nieprawidłowy format numeru PWZFz.',
    validate: value => PWZ(value)
})

Validator.extend('zipcode_pl', {
    getMessage: field => 'Nieprawidłowy format kodu pocztowego.',
    validate: value => (/^[0-9]{2}-[0-9]{3}$/.test(value))
})

Validator.extend('PESEL', {
    getMessage: field => 'Nieprawidłowy format numeru PESEL.',
    validate: value => Pesel(value).valid
})

Validator.extend('date', {
    getMessage: field => 'Nieprawidłowy format daty. (rrrr-mm-dd)',
    validate: value => (/^[1-2][0-9]{3}-[0-1][0-9]-[0-3][0-9]$/.test(value))
})

Validator.extend('youtube_url', {
    getMessage: field => 'Nieprawidłowy adres.',
    validate: value => (/^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/.test(value))
})
